// GENERATED from the v0.9 archive (HenHouse_v0.9.zip) by a one-off port script, then
// maintained by hand. Costs are re-tuned by the balance sim; see docs/plans/v1.0-rewrite.md §5.
import type { BreedId, HenBreedDef } from './types';

export const HEN_BREEDS: Record<BreedId, HenBreedDef> = {
  RIR: {
    id: 'RIR', name: "Rhode Island Red", tier: 'STARTER', cost: 20, layRate: 0.1667, eggValue: 2,
    eggColor: 'brown', broodiness: 1, broodyProne: false, temperament: "hardy",
    special: null, unlock: { kind: 'start' }, spriteRow: 0, pairBonus: 1.15,
    flavor: "The Honda Civic of chickens. Reliable, everywhere, zero drama.",
    birdFact: "Developed in Rhode Island in the 1840s from Malay and Shanghai imports. The official state bird, and one of the foundation stocks of modern commercial brown-egg lines.",
  },
  LEGHORN: {
    id: 'LEGHORN', name: "White Leghorn", tier: 'STARTER', cost: 35, layRate: 0.2667, eggValue: 2,
    eggColor: 'white', broodiness: 0, broodyProne: false, temperament: "flighty",
    special: null, unlock: { kind: 'start' }, spriteRow: 1, pairBonus: 1.2,
    flavor: "Lays like a machine, panics like a squirrel, eats like it is being timed.",
    birdFact: "Originates from Livorno, Italy. Commercial white-egg layers are almost all Leghorn-derived — they are the hen equivalent of the Holstein cow.",
  },
  BUFF_ORPINGTON: {
    id: 'BUFF_ORPINGTON', name: "Buff Orpington", tier: 'STARTER', cost: 25, layRate: 0.1, eggValue: 2,
    eggColor: 'brown', broodiness: 5, broodyProne: true, temperament: "docile",
    special: "broody_hatcher", unlock: { kind: 'start' }, spriteRow: 2, pairBonus: 1,
    flavor: "Built like a golden pillow. Will sit on anything. ANYTHING.",
    birdFact: "Bred by William Cook in Orpington, Kent in 1886. Known as the \"golden retriever of chickens\" — broody to a fault, will sit on a rock if you let her.",
  },
  WYANDOTTE: {
    id: 'WYANDOTTE', name: "Wyandotte", tier: 'STARTER', cost: 30, layRate: 0.1333, eggValue: 2.4,
    eggColor: 'brown', broodiness: 3, broodyProne: true, temperament: "calm",
    special: "silver_egg_chance", unlock: { kind: 'start' }, spriteRow: 3, pairBonus: 1.15,
    flavor: "Calm, gorgeous. Pair her with a Wyandotte rooster if you want actual silver eggs.",
    birdFact: "Developed in 1870s New York, named after the Wyandot people. The distinctive \"laced\" feather pattern was one of the first to be standardized in American poultry shows.",
  },
  AUSTRALORP: {
    id: 'AUSTRALORP', name: "Australorp", tier: 'EARLY', cost: 175, layRate: 0.2, eggValue: 2,
    eggColor: 'brown', broodiness: 2, broodyProne: false, temperament: "docile",
    special: "record_keeper", unlock: { kind: 'roosters', count: 1 }, spriteRow: 4, pairBonus: 1.2,
    flavor: "Holds the world egg-laying record (364 in 365 days). Will not shut up about it.",
    birdFact: "An Australian refinement of the Orpington. In 1922, an Australorp hen laid 364 eggs in 365 days — a world record that still stands.",
  },
  PLYMOUTH_ROCK: {
    id: 'PLYMOUTH_ROCK', name: "Plymouth Rock", tier: 'EARLY', cost: 200, layRate: 0.1834, eggValue: 2,
    eggColor: 'brown', broodiness: 2, broodyProne: true, temperament: "docile",
    special: "utility_broody", unlock: { kind: 'roosters', count: 1 }, spriteRow: 5, pairBonus: 1.15,
    flavor: "Striped. Sturdy. Has a retirement plan.",
    birdFact: "The black-and-white barred Plymouth Rock was America most popular breed from 1870 to WWII. Bred for winter laying in New England farms.",
  },
  ISA_BROWN: {
    id: 'ISA_BROWN', name: "ISA Brown", tier: 'EARLY', cost: 100, layRate: 0.2334, eggValue: 2,
    eggColor: 'brown', broodiness: 0, broodyProne: false, temperament: "calm",
    special: null, unlock: { kind: 'roosters', count: 1 }, spriteRow: 6, pairBonus: 1,
    flavor: "Corporate egg machine. No personality. All business.",
    birdFact: "A 1978 hybrid cross from the Institut de Sélection Animale in France. Modern factory farms lean on ISAs because they lay 300+ brown eggs a year and then quietly retire.",
  },
  WELSUMMER: {
    id: 'WELSUMMER', name: "Welsummer", tier: 'EARLY', cost: 250, layRate: 0.15, eggValue: 3,
    eggColor: 'speckled', broodiness: 1, broodyProne: false, temperament: "active",
    special: "golden_egg_affinity", unlock: { kind: 'roosters', count: 1 }, spriteRow: 7, pairBonus: 1.2,
    flavor: "Her eggs look like they belong in a fancy brunch you cannot afford.",
    birdFact: "The Kellogg Corn Flakes rooster (Cornelius) is a Welsummer. Her dark speckled eggs are the closest any chicken gets to a wild game-bird egg.",
  },
  NEW_HAMPSHIRE_RED: {
    id: 'NEW_HAMPSHIRE_RED', name: "New Hampshire Red", tier: 'EARLY', cost: 150, layRate: 0.1667, eggValue: 2,
    eggColor: 'brown', broodiness: 2, broodyProne: false, temperament: "competitive",
    special: "accelerant", unlock: { kind: 'roosters', count: 1 }, spriteRow: 8, pairBonus: 1,
    flavor: "Basically an RIR who went to a different college. Do NOT confuse them.",
    birdFact: "Split from Rhode Island Red stock in the 1920s for faster feathering and earlier laying. The breed Colonel Sanders fed KFC for decades.",
  },
  AMERAUCANA: {
    id: 'AMERAUCANA', name: "Ameraucana", tier: 'MID', cost: 350000, layRate: 0.1667, eggValue: 5.7,
    eggColor: 'blue', broodiness: 1, broodyProne: false, temperament: "gentle",
    special: "blue_eggs_silver", unlock: { kind: 'hens', count: 12 }, spriteRow: 9, pairBonus: 1,
    flavor: "Blue eggs. Yes, really blue. No, she is not sick.",
    birdFact: "Derived from the Araucana of Chile. The blue-egg gene (oocyan) descends from a single retrovirus insertion ~1970 — every blue egg on Earth traces to that mutation.",
  },
  BLACK_COPPER_MARANS: {
    id: 'BLACK_COPPER_MARANS', name: "Black Copper Marans", tier: 'MID', cost: 250000, layRate: 0.1333, eggValue: 6.4,
    eggColor: 'chocolate', broodiness: 2, broodyProne: false, temperament: "calm",
    special: "chocolate_eggs", unlock: { kind: 'hens', count: 12 }, spriteRow: 10, pairBonus: 1.25,
    flavor: "Lays chocolate-colored eggs. Tastes like regular eggs. Life is cruel.",
    birdFact: "The \"chocolate\" egg color comes from a hyper-thick protoporphyrin layer applied late in the oviduct. James Bond canonically eats Marans eggs in the novels.",
  },
  EASTER_EGGER: {
    id: 'EASTER_EGGER', name: "Easter Egger", tier: 'MID', cost: 10000, layRate: 0.1834, eggValue: 3,
    eggColor: 'rainbow', broodiness: 1, broodyProne: false, temperament: "friendly",
    special: "rainbow_egg_spawner", unlock: { kind: 'roosters', count: 2 }, spriteRow: 11, pairBonus: 1,
    flavor: "Every egg is a mystery flavor. Even she does not know.",
    birdFact: "Technically not a breed — any blue-egg crossbred hen. Every Easter Egger's egg color is set for life by her own genetics: one hen's eggs are always the same color.",
  },
  CREAM_LEGBAR: {
    id: 'CREAM_LEGBAR', name: "Cream Legbar", tier: 'MID', cost: 50000, layRate: 0.2, eggValue: 3.6,
    eggColor: 'blue', broodiness: 1, broodyProne: false, temperament: "active",
    special: "paired_bonus", unlock: { kind: 'roosters', count: 2 }, spriteRow: 12, pairBonus: 1,
    flavor: "Blue eggs AND an attitude. Knows exactly what she is worth.",
    birdFact: "Created by Reginald Punnett (yes, the Punnett-square guy) at Cambridge in the 1930s. Autosexing — chicks can be sorted by sex at hatch just by feather pattern.",
  },
  BARNEVELDER: {
    id: 'BARNEVELDER', name: "Barnevelder", tier: 'MID', cost: 25000, layRate: 0.15, eggValue: 4.3,
    eggColor: 'dark_speckled', broodiness: 1, broodyProne: false, temperament: "calm",
    special: "achievement_affinity", unlock: { kind: 'hens', count: 15 }, spriteRow: 13, pairBonus: 1,
    flavor: "Double-laced feathers. Double-laced ambition. Collects achievements for fun.",
    birdFact: "From Barneveld, Netherlands. Her \"double-laced\" feather pattern is so precise that breeders score each feather on a 1-10 scale at shows.",
  },
  SILKIE: {
    id: 'SILKIE', name: "Silkie", tier: 'LATE', cost: 100000, layRate: 0.0833, eggValue: 2.4,
    eggColor: 'cream', broodiness: 5, broodyProne: true, temperament: "docile",
    special: "master_broody", unlock: { kind: 'roosters', count: 2 }, spriteRow: 14, pairBonus: 1,
    flavor: "Soft as a hug, peaceful as morning. The most beloved bird in any coop.",
    birdFact: "Documented in 13th-century Chinese medical texts. The silky plumage is a mutation (Silkie gene) that deactivates the barbicels that zip normal feathers together.",
  },
  BIELEFELDER: {
    id: 'BIELEFELDER', name: "Bielefelder", tier: 'LATE', cost: 150000, layRate: 0.2167, eggValue: 3.5,
    eggColor: 'brown', broodiness: 0, broodyProne: false, temperament: "gentle",
    special: "gentle_giant", unlock: { kind: 'roosters', count: 3 }, spriteRow: 15, pairBonus: 1,
    flavor: "Enormous. Gentle. Makes everyone around her mysteriously productive.",
    birdFact: "Bred in Bielefeld, Germany in 1976 by Gerd Roth. Designed from the start to be cold-hardy, gentle, and auto-sexing all at once.",
  },
  SVART_HONA: {
    id: 'SVART_HONA', name: "Svart Hona", tier: 'LATE', cost: 1000000, layRate: 0.1167, eggValue: 11.1,
    eggColor: 'cream', broodiness: 3, broodyProne: false, temperament: "alert",
    special: "midnight_layer", unlock: { kind: 'roosters', count: 3 }, spriteRow: 16, pairBonus: 1,
    flavor: "Black feathers. Black skin. Black bones. Black eggs would be too on-the-nose.",
    birdFact: "Swedish \"Black Hen\" — descended from a 400-year-old isolated population on the island of Öland. Hyperpigmentation (fibromelanosis) shared only with the Ayam Cemani.",
  },
  OLIVE_EGGER: {
    id: 'OLIVE_EGGER', name: "Olive Egger", tier: 'LATE', cost: 80000, layRate: 0.1667, eggValue: 4.2,
    eggColor: 'olive', broodiness: 2, broodyProne: false, temperament: "friendly",
    special: "olive_eggs", unlock: { kind: 'roosters', count: 2 }, spriteRow: 17, pairBonus: 1,
    flavor: "Green eggs. No ham. Dr. Seuss sends royalties.",
    birdFact: "Olive shells are blue + brown coat, applied sequentially in the oviduct. Olive Eggers are F1 crosses of blue-egg parents × dark-brown-egg parents.",
  },
  SPECKLED_SUSSEX: {
    id: 'SPECKLED_SUSSEX', name: "Speckled Sussex", tier: 'LATE', cost: 50000, layRate: 0.1667, eggValue: 3.9,
    eggColor: 'cream', broodiness: 3, broodyProne: true, temperament: "curious",
    special: "loyalty_bonus", unlock: { kind: 'roosters', count: 2 }, spriteRow: 18, pairBonus: 1,
    flavor: "Gets better every day she stays. The compound interest of chickens.",
    birdFact: "Origin traced to Sussex, England, pre-Roman. The speckle count increases every moult — an old Sussex has markedly more speckles than a young one.",
  },
  AYAM_CEMANI: {
    id: 'AYAM_CEMANI', name: "Ayam Cemani", tier: 'RARE', cost: 5000000, layRate: 0.1, eggValue: 18,
    eggColor: 'cream', broodiness: 2, broodyProne: false, temperament: "alert",
    special: "dark_aura", unlock: { kind: 'roosters', count: 5 }, spriteRow: 31, pairBonus: 1.3,
    flavor: "The Lamborghini of chickens. All black. Eggs sell at midnight prices.",
    birdFact: "Indonesian breed, once reserved for royalty. Fibromelanosis turns skin, bones, organs, and even the inside of the feathers jet black. Blood stays red.",
  },
  POLISH: {
    id: 'POLISH', name: "Polish", tier: 'RARE', cost: 400000, layRate: 0.1167, eggValue: 6.8,
    eggColor: 'white', broodiness: 1, broodyProne: false, temperament: "nervous",
    special: "blind_spot", unlock: { kind: 'roosters', count: 4 }, spriteRow: 19, pairBonus: 1,
    flavor: "Cannot see through her own hairdo. Does not care. Vibes only.",
    birdFact: "No actual connection to Poland — the name comes from Dutch \"polled\" (crested). A selective breeding accident in the 1500s cemented the feather bouffant.",
  },
  FRIZZLE: {
    id: 'FRIZZLE', name: "Frizzle", tier: 'RARE', cost: 600000, layRate: 0.1333, eggValue: 2,
    eggColor: 'brown', broodiness: 2, broodyProne: false, temperament: "friendly",
    special: "frizzled_luck", unlock: { kind: 'roosters', count: 3 }, spriteRow: 20, pairBonus: 1,
    flavor: "Every feather a tiny celebration. She walks on sunshine and brings the luck with her.",
    birdFact: "Not a breed but a gene (mf). Heterozygous frizzles are curly; homozygous \"frazzles\" have brittle feathers that snap — bad welfare, usually culled.",
  },
  TURKEN: {
    id: 'TURKEN', name: "Turken", tier: 'RARE', cost: 360000, layRate: 0.2, eggValue: 4,
    eggColor: 'brown', broodiness: 2, broodyProne: false, temperament: "hardy",
    special: null, unlock: { kind: 'roosters', count: 3 }, spriteRow: 21, pairBonus: 1,
    flavor: "Naked neck. Full confidence. Zero fashion sense. Maximum egg output.",
    birdFact: "Not a turkey hybrid. The featherless neck is a single dominant Na gene from Transylvania — bred intentionally in Germany to make plucking easier.",
  },
  SULTAN: {
    id: 'SULTAN', name: "Sultan", tier: 'RARE', cost: 1500000, layRate: 0.0667, eggValue: 18,
    eggColor: 'white', broodiness: 1, broodyProne: false, temperament: "docile",
    special: "royal_crest", unlock: { kind: 'roosters', count: 5 }, spriteRow: 22, pairBonus: 1,
    flavor: "Royal Turkish heritage. Each egg sells like a Fabergé piece. Worth the wait.",
    birdFact: "Bred for the Ottoman court in the 1500s — \"Serai-Taook,\" the fowl of the palace. Nearly extinct by 1900, revived from ~10 birds in English aviaries.",
  },
  DONG_TAO: {
    id: 'DONG_TAO', name: "Dong Tao", tier: 'RARE', cost: 800000, layRate: 0.1, eggValue: 9.5,
    eggColor: 'cream', broodiness: 2, broodyProne: false, temperament: "calm",
    special: null, unlock: { kind: 'roosters', count: 5 }, spriteRow: 23, pairBonus: 1,
    flavor: "Those feet. Those enormous, terrifying feet. Worth every egg.",
    birdFact: "Vietnamese heritage breed. The scaled \"dragon feet\" are a genuine genetic trait; an adult Dong Tao rooster's legs can be as thick as a human wrist.",
  },
  BRAHMA: {
    id: 'BRAHMA', name: "Brahma", tier: 'RARE', cost: 700000, layRate: 0.1834, eggValue: 5.2,
    eggColor: 'brown', broodiness: 3, broodyProne: true, temperament: "gentle",
    special: "flock_synergy", unlock: { kind: 'roosters', count: 4 }, spriteRow: 24, pairBonus: 1,
    flavor: "Gentle giant. Could crush you. Chooses not to. Feathered feet.",
    birdFact: "Developed in the 1850s from \"Shanghai\" imports via the port of Brahmaputra. Called \"King of Chickens\" — roosters hit 12+ pounds and stand taller than most dogs.",
  },
  COCHIN: {
    id: 'COCHIN', name: "Cochin", tier: 'RARE', cost: 440000, layRate: 0.1333, eggValue: 6,
    eggColor: 'brown', broodiness: 5, broodyProne: true, temperament: "docile",
    special: "warmth_aura_broody", unlock: { kind: 'roosters', count: 3 }, spriteRow: 25, pairBonus: 1,
    flavor: "Maximum fluff. Maximum broody. Will adopt anything that holds still.",
    birdFact: "The \"Cochin craze\" of 1853 — Queen Victoria received a pair as a gift and Cochins became the first chicken fad. British poultry clubs were founded to argue about them.",
  },
  SERAMA: {
    id: 'SERAMA', name: "Serama", tier: 'RARE', cost: 560000, layRate: 0.1667, eggValue: 5.1,
    eggColor: 'cream', broodiness: 2, broodyProne: false, temperament: "bold",
    special: null, unlock: { kind: 'roosters', count: 4 }, spriteRow: 26, pairBonus: 1,
    flavor: "World smallest chicken. World biggest ego. Struts like she owns the farm.",
    birdFact: "Malaysian breed — the world's smallest chicken. An adult hen weighs 250-500g, about the weight of a can of soup. Bred for posture: they pose.",
  },
  JAPANESE_BANTAM: {
    id: 'JAPANESE_BANTAM', name: "Japanese Bantam", tier: 'RARE', cost: 900000, layRate: 0.15, eggValue: 6.7,
    eggColor: 'cream', broodiness: 4, broodyProne: true, temperament: "proud",
    special: "adjacency_serama", unlock: { kind: 'roosters', count: 4 }, spriteRow: 27, pairBonus: 1,
    flavor: "Short legs. Tall attitude. Will fight a rooster twice her size.",
    birdFact: "Called \"Chabo\" in Japan — a 7th-century court ornamental. Bred for legs so short the toes barely clear the ground when walking.",
  },
  SEBRIGHT: {
    id: 'SEBRIGHT', name: "Sebright", tier: 'RARE', cost: 1200000, layRate: 0.1834, eggValue: 6,
    eggColor: 'cream', broodiness: 0, broodyProne: false, temperament: "active",
    special: "rare_collector", unlock: { kind: 'roosters', count: 5 }, spriteRow: 28, pairBonus: 1,
    flavor: "Laced feathers like chainmail. Collects things. Judges you quietly.",
    birdFact: "Bred by Sir John Saunders Sebright, 7th Baronet, around 1810. His breeding manual is the earliest known work on domestic genetics, predating Darwin by 50 years.",
  },
  MILLE_FLEUR_DUCCLE: {
    id: 'MILLE_FLEUR_DUCCLE', name: "Mille Fleur D'Uccle", tier: 'RARE', cost: 1100000, layRate: 0.1667, eggValue: 6.3,
    eggColor: 'cream', broodiness: 3, broodyProne: true, temperament: "friendly",
    special: "bloom_event", unlock: { kind: 'roosters', count: 4 }, spriteRow: 29, pairBonus: 1,
    flavor: "A thousand flowers on every feather. Instagram would love her.",
    birdFact: "Belgian bantam — \"Mille Fleur\" means \"thousand flowers\" for the tri-colored feather pattern, each feather carrying a white tip, black crescent, and mahogany body.",
  },
};

/** Canonical display order (starter → rare), matching v0.9 data order. */
export const BREED_IDS: readonly BreedId[] = [
  'RIR', 'LEGHORN', 'BUFF_ORPINGTON', 'WYANDOTTE', 'AUSTRALORP', 'PLYMOUTH_ROCK', 'ISA_BROWN', 'WELSUMMER', 'NEW_HAMPSHIRE_RED', 'AMERAUCANA', 'BLACK_COPPER_MARANS', 'EASTER_EGGER', 'CREAM_LEGBAR', 'BARNEVELDER', 'SILKIE', 'BIELEFELDER', 'SVART_HONA', 'OLIVE_EGGER', 'SPECKLED_SUSSEX', 'AYAM_CEMANI', 'POLISH', 'FRIZZLE', 'TURKEN', 'SULTAN', 'DONG_TAO', 'BRAHMA', 'COCHIN', 'SERAMA', 'JAPANESE_BANTAM', 'SEBRIGHT', 'MILLE_FLEUR_DUCCLE',
];
